(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@ceridianhcm/globalization"));
	else if(typeof define === 'function' && define.amd)
		define(["PXTGlobalization/globalization"], factory);
	else if(typeof exports === 'object')
		exports["platformCore"] = factory(require("@ceridianhcm/globalization"));
	else
		root["platformCore"] = factory(root["PXTGlobalization/globalization"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__5238__) => {
return 